import { styled, Inlinelink } from '@creditas-ui/react';

export const Link = styled(Inlinelink)`
  text-decoration: none;
`;
